import { addDays, addYears, subDays, subMonths } from 'date-fns';
import { useEffect } from 'react';
import classNames from 'classnames';
import BookingSectionTitle from '../../Booking/BookingSectionTitle';
import SelectComponent from '../../SelectComponent';
import styles from './ClosureObjectMain.module.scss';
import { FormikProps, useFormikContext } from 'formik';
import {
  BookingFormType,
  FormClosureObjectType,
} from '../../../redux/types/bookingTypes';
import { useSelector } from 'react-redux';
import { BookingSelectors } from '../../../redux/reducers/bookingSlice';
import { createObjectList } from '../../Booking/functions';
import { closureReason } from '../../../utils/constants';
import BookingLineTitle from '../../Booking/BookingLineTitle';
import Calendar from '../../Calendar';

type ClosureObjectProps = {
  windowType?: BookingFormType;
  formik: FormikProps<FormClosureObjectType>;
  closureNote?: FormClosureObjectType;
};

const ClosureObjectMain = ({
  windowType,
  formik,
  closureNote,
}: ClosureObjectProps) => {
  const { setFieldValue } = useFormikContext();
  const {
    handleChange,
    values,
    errors,
    setFieldTouched,
    touched,
    validateField,
    initialValues,
  } = formik;
  const objects = useSelector(BookingSelectors.getChessObjects);
  const optionList = objects ? createObjectList(objects) : [];
  const today = new Date();
  const startCalendar = subMonths(new Date(), 1);
  const endCalendar = addYears(new Date(), 1);
  const endCalendarForCheckIn = subDays(endCalendar, 1);

  useEffect(() => {
    if (values.start_closure && values.start_closure > values.end_closure) {
      setFieldValue('end_closure', addDays(values.start_closure, 1));
    }
  }, [touched, values]);

  return (
    <>
      <BookingSectionTitle title="Закрыть объект для бронирования" />
      <div className={styles.container}>
        <div className={classNames(styles.line)}>
          <div className={styles.column}>
            <SelectComponent
              name="rental_object"
              id="rental_object"
              title={windowType === BookingFormType.view ? 'Объект' : 'Объект*'}
              optionsList={optionList}
              currentValue={
                (values.rental_object && values.rental_object.toString()) || ''
              }
              setSelecValue={handleChange('rental_object')}
              isBooking={true}
              onBlur={() => setFieldTouched('rental_object')}
              errText={errors.rental_object}
              isDisabled={windowType === BookingFormType.view ? true : false}
            />
          </div>
          <div className={styles.column}>
            <SelectComponent
              name="reason"
              id="reason"
              title={
                windowType === BookingFormType.view ? 'Причина' : 'Причина*'
              }
              optionsList={closureReason}
              currentValue={values.reason}
              setSelecValue={handleChange('reason')}
              isBooking={true}
              onBlur={() => setFieldTouched('reason')}
              errText={errors.reason}
              isDisabled={windowType === BookingFormType.view ? true : false}
            />
          </div>
        </div>
        <div
          className={classNames(
            styles.line,
            styles.dateBlock,
            windowType !== BookingFormType.view && styles.edit,
          )}
        >
          <div>
            <BookingLineTitle
              title={
                windowType === BookingFormType.view
                  ? 'Дата начала'
                  : 'Дата начала*'
              }
            />
            <Calendar
              name="start_closure"
              id="start_closure"
              disabled={windowType === BookingFormType.view ? true : false}
              placeholderText="Выберите дату начала"
              selectedDate={values.start_closure}
              onChange={(val) => {
                setFieldValue('start_closure', val);
              }}
              isSmall={true}
              minDate={
                windowType === BookingFormType.edit ? startCalendar : today
              }
              maxDate={endCalendarForCheckIn}
              isError={!!errors.start_closure}
              onBlur={() => setFieldTouched('start_closure')}
              errText={errors.start_closure}
              inputClassname="closure"
            />
          </div>

          <div className={styles.out}>
            <BookingLineTitle
              title={
                windowType === BookingFormType.view
                  ? 'Дата окончания'
                  : 'Дата окончания*'
              }
            />
            <Calendar
              name="end_closure"
              id="end_closure"
              disabled={windowType === BookingFormType.view ? true : false}
              placeholderText="Выберите дату выезда"
              selectedDate={values.end_closure}
              onChange={(val) => {
                setFieldValue('end_closure', val);
              }}
              isSmall={true}
              minDate={
                (values.end_closure && addDays(values.start_closure, 1)) ||
                addDays(today, 1)
              }
              maxDate={endCalendar}
              isError={!!errors.end_closure}
              onBlur={() => setFieldTouched('end_closure')}
              errText={errors.end_closure}
              inputClassname="closure"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ClosureObjectMain;
